export const visit = (vm, at) => {
at({ "pt-br": { "featureTables": { "compare": { "screenReader": { "featureAvailable": "recurso dispon\xEDvel", "featureUnavailable": "recurso indispon\xEDvel" } } } } });
};